/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { StockReportDTO } from './StockReportDTO';
import {
    StockReportDTOFromJSON,
    StockReportDTOFromJSONTyped,
    StockReportDTOToJSON,
} from './StockReportDTO';

/**
 * 
 * @export
 * @interface StockReportPageDTO
 */
export interface StockReportPageDTO {
    /**
     * 
     * @type {Array<StockReportDTO>}
     * @memberof StockReportPageDTO
     */
    content?: Array<StockReportDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof StockReportPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockReportPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockReportPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof StockReportPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof StockReportPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof StockReportPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof StockReportPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof StockReportPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof StockReportPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the StockReportPageDTO interface.
 */
export function instanceOfStockReportPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StockReportPageDTOFromJSON(json: any): StockReportPageDTO {
    return StockReportPageDTOFromJSONTyped(json, false);
}

export function StockReportPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockReportPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(StockReportDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function StockReportPageDTOToJSON(value?: StockReportPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(StockReportDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

